import React from 'react';
import Select from 'react-select';
import './custom-dropdown.scss';

class CustomDropDown extends React.Component{
    constructor(props){
        super()
        this.state = {
            changeClass: false
        }
    }

    render(){

        const { options, value, onChange, isDisabled, defaultValue } = this.props

        return (
            <span style={{ fontSize: '15px', minWidth:'200px'}}>
                <span className="css-1uccc91-singleValue-default-value">
                    { defaultValue || "" }
                </span>
                <Select
                    isDisabled={ isDisabled || false }
                    classNamePrefix="select"
                    className={defaultValue !== undefined ? "custom-dropdown-conditional" : ""}    
                    isSearchable={true}
                    name="color"
                    options={options}
                    value = { value }
                    onChange={ onChange }
                />
            </span>    
        )
    } 
}

export const DropDownSize = (props) => {
    return(
        <div className="dropdown-size">
            { props.children }
        </div>
    )
} 

export default CustomDropDown

